import { render, staticRenderFns } from "./BindsAvatar.vue?vue&type=template&id=67711a94&"
import script from "./BindsAvatar.vue?vue&type=script&lang=js&"
export * from "./BindsAvatar.vue?vue&type=script&lang=js&"
import style0 from "./BindsAvatar.vue?vue&type=style&index=0&id=67711a94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports